/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */
import VueI18n from 'vue-i18n';

require('./spark-bootstrap');
import VueLazyload from 'vue-lazyload';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import SegmentTracker from "./plugins/segment-tracker";

Vue.use(VueLazyload, {
    attempt: 1,
    preLoad: 1.3,
    listenEvents: ['scroll'],
    lazyComponent: true
});

function lazyLoad(component) {
    return () => import('' + component + '');
}

// Alerts
Vue.component('alert-message', lazyLoad('./alerts'));
Vue.component('spark-notifications', lazyLoad('./spark-components/notifications/notifications'));

// Navbar
Vue.component('spark-navbar', lazyLoad('./spark-components/navbar/navbar'));

// Profile
Vue.component('spark-profile', lazyLoad('./spark-components/settings/profile'));
Vue.component('spark-update-profile-photo', lazyLoad('./spark-components/settings/profile/update-profile-photo'));
Vue.component('spark-update-contact-information', lazyLoad('./spark-components/settings/profile/update-contact-information'));
Vue.component('spark-update-contact-information', lazyLoad('./spark-components/settings/profile/update-contact-information'));

// Teams
Vue.component('spark-teams', lazyLoad('./spark-components/settings/teams'));
Vue.component('spark-create-team', lazyLoad('./spark-components/settings/teams/create-team'));
Vue.component('spark-pending-invitations', lazyLoad('./spark-components/settings/teams/pending-invitations'));
Vue.component('spark-current-teams', lazyLoad('./spark-components/settings/teams/current-teams'));
Vue.component('spark-team-settings', lazyLoad('./spark-components/settings/teams/team-settings'));
Vue.component('spark-team-profile', lazyLoad('./spark-components/settings/teams/team-profile'));
Vue.component('spark-team-membership', lazyLoad('./spark-components/settings/teams/team-membership'));
Vue.component('spark-update-team-photo', lazyLoad('./spark-components/settings/teams/update-team-photo'));
Vue.component('spark-update-team-name', lazyLoad('./spark-components/settings/teams/update-team-name'));
Vue.component('spark-mailed-invitations', lazyLoad('./spark-components/settings/teams/mailed-invitations'));
Vue.component('spark-send-invitation', lazyLoad('./spark-components/settings/teams/send-invitation'));
Vue.component('spark-team-members', lazyLoad('./spark-components/settings/teams/team-members'));
Vue.component('current-subscription', lazyLoad('./components/teams/current-subscription'));
Vue.component('select-subscription', lazyLoad('./components/teams/select-subscription'));
Vue.component('team-timezone', lazyLoad('./components/teams/timezone'));
Vue.component('quota-progress', lazyLoad('./components/teams/quota-progress'));
Vue.component('team-azure-organization', lazyLoad('./components/teams/azure-organization'));

// Spark
Vue.component('spark-settings', lazyLoad('./spark-components/settings/settings'));

// Forms
Vue.component('admin-forms', lazyLoad('./components/admin-components/forms/forms'));
Vue.component('forms-create-modal', lazyLoad('./components/forms/create'));
Vue.component('form-setup', lazyLoad('./components/admin-components/forms/form-setup'));
Vue.component('admin-form-submissions-chart', lazyLoad('./components/admin-components/forms/form-submissions-chart'));
Vue.component('admin-form-submission', lazyLoad('./components/admin-components/forms/form-submission'));
Vue.component('submission-status', lazyLoad('./components/forms/submission-status'));
Vue.component('forms-edit', lazyLoad('./components/forms/edit'));
Vue.component('double-opt-in', lazyLoad('./components/forms/subscription'));
Vue.component('submission-files', lazyLoad('./components/forms/submission-files'));
Vue.component('data-mapping', lazyLoad('./components/forms/data-mapping'));
Vue.component('color-picker', lazyLoad('./components/forms/color-picker'));
Vue.component('attachments', lazyLoad('./components/forms/page-appearance-attachments'));
Vue.component('submitter-notifications', lazyLoad('./components/forms/submitter-notifications'));
Vue.component('conditional-submission-notifications', lazyLoad('./components/forms/conditional-submission-notifications'));
Vue.component('integrations-webhooks', lazyLoad('./components/forms/integrations-webhooks'));
Vue.component('form-builder', lazyLoad('./components/form-builder/FormBuilder'));
Vue.component('form-builder-item', lazyLoad('./components/form-builder/FormBuilderItem'));
Vue.component('form-builder-page-appearance', lazyLoad('./components/form-builder/components/page-appearance'));
Vue.component('form-action-token', lazyLoad('./components/forms/action-token'));
Vue.component('form-top-country', lazyLoad('./components/forms/top-country'));
Vue.component('form-top-devices', lazyLoad('./components/forms/top-devices'));
Vue.component('referral-link', lazyLoad('./components/forms/referral-link'));
Vue.component('form-spam-settings', lazyLoad('./components/forms/spam-settings'));
Vue.component('form-integrations', lazyLoad('./components/forms/form-integrations'));

// Other
Vue.component('emails-input', lazyLoad('./components/elements/emails-input'));
Vue.component('disabled-block', lazyLoad('./components/elements/disabled-block'));
Vue.component('nice-select', lazyLoad('./components/elements/nice-select'));
Vue.component('social-share', lazyLoad('./components/elements/social-share'));
Vue.component('pagination', lazyLoad('./components/elements/pagination'));
Vue.component('select-switcher', lazyLoad('./components/elements/select-switcher'));
Vue.component('editable-header', lazyLoad('./components/elements/editable-header'));
Vue.component('html-editor-field', lazyLoad('./components/elements/html-editor-field'));
Vue.component('modal', lazyLoad('./components/elements/modal-template'));
Vue.component('tfa-code-input', lazyLoad('./components/elements/tfa-code-input'));
Vue.component('country-code', lazyLoad('./components/elements/country-code'));
//code highlighter/editor
Vue.component('code-highlighter', lazyLoad('./components/elements/code-highlighter'));
// cropper
Vue.component('cropper', lazyLoad('./components/elements/cropper-template'));
// wysiwyg
Vue.component('suneditor', lazyLoad('./components/elements/suneditor'));

// Profile
Vue.component('payment-methods', lazyLoad('./components/profile/payment-methods'));
Vue.component('upcoming-invoices', lazyLoad('./components/profile/upcoming-invoices'));
Vue.component('payment-history', lazyLoad('./components/profile/payment-history'));

// Security
Vue.component('spark-security', lazyLoad('./spark-components/settings/security'));
Vue.component('spark-update-password', lazyLoad('./spark-components/settings/security/update-password'));
Vue.component('spark-enable-two-factor-auth', lazyLoad('./spark-components/settings/security/enable-two-factor-auth'));
Vue.component('spark-disable-two-factor-auth', lazyLoad('./spark-components/settings/security/disable-two-factor-auth'));

// API
Vue.component('spark-api', lazyLoad('./spark-components/settings/api'));
Vue.component('spark-create-token', lazyLoad('./spark-components/settings/api/create-token'));
Vue.component('spark-tokens', lazyLoad('./spark-components/settings/api/tokens'));
Vue.component('update-password', lazyLoad('./spark-components/settings/profile/update-password'));

// Auth
Vue.component('spark-register-stripe', lazyLoad('./spark-components/auth/register-stripe'));
Vue.component('spark-login', lazyLoad('./spark-components/auth/login'));
Vue.component('spark-password-reset', lazyLoad('./spark-components/auth/reset'));

// Wizard
Vue.component('wizard-steps', lazyLoad('./components/wizard/steps'));
Vue.component('wizard-submit-form', lazyLoad('./components/wizard/submission-form'));

// Hosted forms
Vue.component('hosted-form-validated-field', lazyLoad('./hosted/components/ValidatedField'))

let VueCookie = require('vue-cookie');
let momentTz = require('moment-timezone');

Vue.use(VueCookie);

Vue.component('delete-account', lazyLoad('./components/admin-components/settings/delete-account'));
Vue.component('text-copy-input', lazyLoad('./components/style-guide/text-copy-input'));
Vue.component('search-input', lazyLoad('./components/style-guide/search-input'));
Vue.component('size-range-input', lazyLoad('./components/forms/size-range-input'));
Vue.component('loader', lazyLoad('./components/elements/loader'))
Vue.component('loading', Loading);
Vue.component('restriction-modal', lazyLoad('./components/modals/restriction-modal'));
Vue.component('base-modal', lazyLoad('./components/modals/_base-modal'));
Vue.component('invite-restriction', lazyLoad('./components/admin-components/teams/invite-restriction'));
Vue.component('cancel-subscription-modal', lazyLoad('./components/modals/cancel-subscription-modal'));
Vue.component('cancel-subscription-button', lazyLoad('./components/elements/cancel-subscription-button'));

Vue.component('tfa-handle-login', lazyLoad('./components/auth/tfa-handle-login'));

Vue.use(VueI18n);
Vue.use(SegmentTracker);

let {errorHandling} = require('./mixins/error-handling');
function loadLang(cb) {
    function readTextFile(file, callback) {
        let rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", file, true);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4 && rawFile.status == "200") {
                callback(rawFile.responseText);
            }
        };
        rawFile.send(null);
    }

    readTextFile(Spark.vueLangFilePath, function (text) {
        const Messages = JSON.parse(text);
        cb(Messages);
    });
}

function launch(messages) {
    // Create VueI18n instance with options
    const i18n = new VueI18n({
        locale: Spark.currentLanguage,
        fallbackLocale: 'default',
        messages,
    });

    let app = new Vue({
        mixins: [require('spark'), errorHandling],
        i18n,
        /**
         * The application's data.
         */
        data: {
            lang: Spark.currentLanguage,
            errorMessage: null,
            successMessage: null,
            applicationSettings: Spark.applicationSettings,

            user: Spark.state.user,
            teams: Spark.state.teams,
            currentTeam: Spark.state.currentTeam,
            userTimeZone: moment.tz.guess(),

            loadingNotifications: false,
            notifications: null,

            supportForm: new SparkForm({
                from: '',
                subject: '',
                message: ''
            }),

            isLoading: false,
            restrictionModal: {
                show: false,
                restriction: null,
                data: null
            },
            toggleSidebar: true,
            sidebarStateChange: false,
            contentTabs: true,
            splashPage: false,
            contentSimplify: false,
            isDarkTheme: null
        },

        created() {
            this.isDarkTheme = !!Spark?.state?.user?.is_dark_theme;
            // rewrite some spark data
            let team = Spark.state.currentTeam,
                currentTeamMember = team ? _.find(Spark.state.currentTeam.users, user => user.id === Spark.state.user.id) : null;
            if (team) {
                team.current_user_role = currentTeamMember ? currentTeamMember.pivot.role : null;
                team.isOwner = () => {
                    return team.current_user_role === 'owner';
                };
            }
            this.currentTeam = team;

            // Set user timezone
            if (!this.$cookie.get('timezone')) {
                this.$cookie.set('timezone', momentTz.tz.guess(), {
                    secure: process.env.MIX_SESSION_SECURE_COOKIE === 'true',
                    expires: 365,
                    domain: process.env.MIX_SESSION_DOMAIN,
                    samesite: 'lax'
                });
            }
            this.$analytics.identifyUser(Spark.state.user, team);
            this.$analytics.trackCustomPageView();
        },

        updated: function () {
            this.$nextTick(function () {
                this.focusModalInput();
            })
        },

        methods: {
            focusModalInput() {
                $('[data-bs-toggle="modal"]').click(function (e) {
                    let target = $(this).attr('data-bs-target') ? $(this).attr('data-bs-target') : $(this).attr('data-target');
                    let focusInput = $(target).find("input").first();
                    setTimeout(function () {
                        $(focusInput).focus();
                    }, 800);
                });
            },
            focusModalInputForce(item) {
                let target = $(item);
                let focusInput = $(target).find("input").first();
                setTimeout(function () {
                    $(focusInput).focus();
                }, 800);
            },

            disableBackdropClickModal(item) {
                $(`#${item}`).modal({backdrop: 'static', keyboard: false})
            },


            /**
             * Mark the current notifications as read.
             */
            // rewrite some spark methods

            markNotificationsAsRead() {
                if (!this.hasUnreadNotifications) {
                    return;
                }
                axios.put('/notifications/read', {
                    notifications: _.map(this.notifications.notifications, 'id')
                });
                // setTimeout(() => this.markNotificationItemsAsRead(), 1000);
            },

            backButton() {
                let currentUrl = window.location.href;
                let arr = currentUrl.split('/');
                arr.pop();

                window.location.href = arr.join('/');
            },

            goTo(href) {
                window.location.href = href;
            },

            /**
             * Copy text from input by $ref name from Vue.
             *
             * @param copiedElement
             */
            copyText(copiedElement) {
                copiedElement.select() ?? copiedElement[0]?.select();
                document.execCommand("copy");
                this.successMessage = this.$t('common.copied');
            },

            copyTextToClipboard(text = null) {
                if (!text) {
                    return;
                }

                const textarea = document.createElement('textarea');
                textarea.value = text;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);

                this.$root.successMessage = this.$t('common.copied');
            },

            getTeamUrl(team, route = null) {
                let urls = [
                    '/teams/' + team?.slug
                ];
                if (route) {
                    urls.push(route);
                }
                return urls.join('/')
            },
            getCurrentTeamUrl(route = null) {
                return this.getTeamUrl(this.currentTeam, route);
            },
            getFormUrl(formId, route = null) {
                let urls = [
                    this.getCurrentTeamUrl(),
                    'forms/' + formId
                ];
                if (route) {
                    urls.push(route);
                }
                return urls.join('/')
            },
            isUrlCurrent(urlToCheck, urlHash = null) {
                if (!urlToCheck) {
                    return false;
                }
                const currentUrl = new URL(window.location.href);
                let url = urlToCheck;
                try {
                    url = new URL(urlToCheck);
                } catch (e) {
                    // Doing nothing
                }
                if(urlHash) {
                    return currentUrl.pathname === (url.pathname ?? url) && currentUrl.hash === urlHash;
                }
                return currentUrl.pathname === (url.pathname ?? url);
            },
            checkRestriction(restriction, showModal = true) {
                this.isLoading = true;
                return axios.post(Spark.restrictionCheckUrl, {
                    restriction
                }).then(({data}) => {
                    if (!data.allowed && showModal) {
                        this.showRestrictionModal(restriction, data.modal);
                    }
                    return data.allowed;
                }).catch((e) => {
                    this.errorHandler(e);

                    return false;
                }).finally(() => this.isLoading = false);
            },
            showRestrictionModal(restriction, data) {
                this.restrictionModal.restriction = restriction;
                this.restrictionModal.data = data;
                this.restrictionModal.show = true;
                if(document.getElementById("modal-restriction-modal")) {
                    $('#modal-restriction-modal').modal('show');
                }
            },
            closeRestrictionModal() {
                this.restrictionModal.restriction = null;
                this.restrictionModal.data = null;
                this.restrictionModal.show = false;
                if(document.getElementById("modal-restriction-modal")) {
                    $('#modal-restriction-modal').modal('hide');
                }
            },
            createFormModal() {
                this.checkRestriction('team_forms', true).then(allowed => {
                    if (allowed) {
                        $('#modal-form-create').modal('toggle');
                        this.focusModalInputForce('#modal-form-create')
                    }
                    // TODO: here we need add limit message or some if allowed = false. Maybe modal with subscription update or redirect there
                });
            },
            generateRestrictionModal(restriction) {
                const modal = {
                    title: this.$t('restrictions.modals.' + restriction + '.title'),
                    message: this.$t('restrictions.modals.' + restriction + '.message', {
                        team: this.currentTeam.name,
                        plan: this.currentTeam.subscription_title
                    }),
                    button: {
                        text: this.$t('restrictions.modals.' + restriction + '.button_text'),
                        url: Spark.subscriptionUpgradeUrl
                    }
                };
                this.showRestrictionModal(restriction, modal);
            }
        },
    });

    Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
    };
}

loadLang(launch);

